import React from "react";
import { motion } from "framer-motion";
import {
  FaUser,
  FaUserGraduate,
  FaMoneyBillWave,
  FaArrowRight,
} from "react-icons/fa";
import { HiDocumentText } from "react-icons/hi";
import { MdOutlineScience } from "react-icons/md";

const services = [
  {
    title: "ANKUR (NURSERY) REGISTRATION",
    icon: <HiDocumentText />,
  },
  {
    title: "SIF 6.0",
    icon: <MdOutlineScience />,
    highlight: true,
  },
  {
    title: "WE #ACT4SDGs",
    icon: <HiDocumentText />,
  },
  {
    title: "ERP LOGIN",
    icon: <FaUser />,
    link: "https://cisnakodar.edunexttechnologies.com/Index",
  },
  {
    title: "ALUMNI REGISTRATION",
    icon: <FaUserGraduate />,
  },
  {
  title: "PAY FEE",
  icon: <FaMoneyBillWave />,
  link: "https://www.cisnakodar.in/admissions/online-fee.html",
},
];

export default function ServicesSection() {
  return (
    <section className="bg-[#f7f9fc] pt-12">

      <div className="max-w-6xl mx-auto px-5">

        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >

          <p className="uppercase tracking-[5px] text-[#d4af37] text-sm font-bold">
            Quick Access
          </p>

          <h2 className="mt-3 text-4xl md:text-5xl font-extrabold text-[#07294d]">
            Student Services
          </h2>

          <div className="flex justify-center mt-5">
            <span className="w-24 h-[3px] bg-[#d4af37] rounded-full"></span>
          </div>

        </motion.div>

        {/* Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">

          {services.map((item, index) => {

            const CardContent = (
              <>
                {/* Gold Top Line */}
                <div className="absolute top-0 left-0 w-full h-1 bg-[#d4af37]"></div>

                <div className="p-6 flex items-center gap-5">

                  {/* Icon */}
                  <div
                    className={`
                      w-14 h-14 rounded-xl flex items-center justify-center text-2xl
                      ${
                        item.highlight
                          ? "bg-[#d4af37] text-[#07294d]"
                          : "bg-[#07294d]/10 text-[#07294d]"
                      }
                    `}
                  >
                    {item.icon}
                  </div>

                  {/* Content */}
                  <div className="flex-1">

                    <h3 className="text-[#07294d] font-bold text-sm md:text-base leading-6">
                      {item.title}
                    </h3>

                    <div className="flex items-center gap-2 mt-3 text-[#d4af37] text-sm font-semibold">

                      <span>
                        Access
                      </span>

                      <FaArrowRight size={12} />

                    </div>

                  </div>

                </div>
              </>
            );

            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{
                  duration: 0.5,
                  delay: index * 0.07,
                }}
                viewport={{ once: true }}
                whileHover={{
                  y: -8,
                }}
                className={`
                  relative overflow-hidden rounded-2xl border bg-white
                  shadow-[0_8px_30px_rgba(0,0,0,0.06)]
                  transition-all duration-300
                  ${
                    item.highlight
                      ? "border-[#d4af37]"
                      : "border-gray-100 hover:border-[#d4af37]"
                  }
                `}
              >

                {item.link ? (
                  <a
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block cursor-pointer"
                  >
                    {CardContent}
                  </a>
                ) : (
                  CardContent
                )}

              </motion.div>
            );
          })}

        </div>

      </div>

    </section>
  );
}